import { useMemo, useSyncExternalStore } from "react";
import { catalogOf, usedProfiles } from "./catalog.ts";
import { store } from "./store.ts";

/** Re-renders on every change of the store. */
export function useStore() {
  const version = useSyncExternalStore(store.subscribe, store.getVersion);
  return { store, version };
}

export function useCatalog() {
  const { version } = useStore();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => (store.replica ? catalogOf(store.replica, store.rights()) : null), [version]);
}

/** With a drink of a second profile the words say „Getränk“ instead of „Wein“ (docs/17-getraenke.md). */
export function useDrinks(): boolean {
  const catalog = useCatalog();
  return catalog ? usedProfiles(catalog).length > 1 : false;
}

export function useLedger() {
  const { version } = useStore();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => store.replica?.state() ?? null, [version]);
}
